<template>
 <!-- 选择地址 -->
     <el-dialog  title="选择地址"  :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"
      :visible.sync="dizhiMark" width="1100px" center>
      <div>
         <el-form :inline="true"  :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="100px" size="mini">
          <mapAddress :addFrom="addFrom"  v-if="dizhiMark" ></mapAddress>
         </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dizhiMark = false">取 消</el-button>
        <el-button type="primary" @click="getAddress('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
</template>
<script>
import mapAddress from '@/components/common/mapAddress.vue'
export default {
  components: {
    mapAddress
  },
  name: 'mapAddressT',
  props: {
    addFrom: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dizhiMark: true
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM

  },
  methods: {
    getAddress () {
      this.$emit('getAddress', this.addFrom)
    },
    closeDialog () {
      this.$emit('destroy')
      this.dizhiMark = false
    }
  }

}
</script>
<style scoped lang='less'>
/deep/.shengSX .el-input__inner {
    width: 220px;
}
/deep/ .bigInp .el-input__inner {
    width: 350px;
}
.el-vue-amap-container{
  height:500px;
}
.mapBox{
position: relative;
}
.search-box {
    width:210px;
    height: 28px;
    border:solid 1px #ccc;
    position: absolute;
    top: 5px;
    left: 5px;
  }
</style>
